import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Capabilities } from './pages/Capabilities';
import { LegacyPage } from './pages/LegacyPage';
import { Locations } from './pages/Locations';
import { EntityData } from './pages/EntityData';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-tech-slate selection:bg-muted-gold selection:text-white flex flex-col" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/capabilities" element={<Capabilities data-id="element-8" />} data-id="element-7" />
            <Route path="/legacy" element={<LegacyPage data-id="element-10" />} data-id="element-9" />
            <Route path="/locations" element={<Locations data-id="element-12" />} data-id="element-11" />
            <Route path="/entity-data" element={<EntityData data-id="element-14" />} data-id="element-13" />
            <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
        <Footer data-id="element-17" />
      </div>
    </BrowserRouter>;
}